import { PRODUCTION } from "@irati/utils/constants/environment";
import env from "@irati/utils/env";
import omitEmpty from "./utils/omitEmpty";
var FINANCE_PERMISSIONS_WHITELIST = [
    "daria.garina@perkbox.com",
    "ed.ellis@perkbox.com",
    "jodie.robinson-mcbride@perkbox.com",
    "mohsin@perkbox.com",
    "richard@perkbox.com",
    "rob.gorle@perkbox.com",
    "katie.bellamy@perkbox.com",
    "natalie.mladenova@perkbox.com",
    "tom.wright@perkbox.com",
    "isobel.raeside@perkbox.com"
];
var canCreate = function (auth) {
    if (env.ENVIRONMENT_NAME !== PRODUCTION) {
        return true;
    }
    if (!auth.user) {
        return false;
    }
    var email = auth.user.email;
    var isWhiteListedFinanceUser = FINANCE_PERMISSIONS_WHITELIST.indexOf(email) >= 0;
    return !!isWhiteListedFinanceUser;
};
export default {
    get: function (token, auth) {
        if (isAdminPortal()) {
            return omitEmpty({});
        }
        var finance = {
            create: canCreate(auth),
            createFraudThresholds: true,
            read: true
        };
        var features = {
            deactivateUsers: false,
            favouriting: false,
            resendWelcomeEmails: false
        };
        var permission = {
            features: omitEmpty(features),
            finance: omitEmpty(finance)
        };
        return omitEmpty(permission);
    }
};
function isAdminPortal() {
    return window && window.location && window.location.hostname.indexOf("admin") === -1;
}
